import { Button, Checkbox, FormControlLabel, FormGroup, Typography } from "@mui/material";
import PopupPaper from "./PopupPaper"
import { useState } from "react";
import { useViewport } from "../../hooks/others/useViewport";
import { CONFIRM_POPUP_WIDTH_STYLE } from "../../utils/constants/viewConstants";

const ConfirmPopupButton = ({buttonData, notShowAgainCheckbox, notShowAgain}) => {
    const DEFAULT_COLOR = "primary";

    return (
        <Button
            color={buttonData.color ? buttonData.color : DEFAULT_COLOR}
            onClick={() => buttonData.onClick(notShowAgainCheckbox && notShowAgain)}
            startIcon = {buttonData.startIcon}
            endIcon = {buttonData.endIcon}    
        >
            {buttonData.text}
        </Button>
    )
}

const ConfirmPopup = ({title, message, notShowAgainCheckbox, buttons}) => {
    const [notShowAgain, setNotShowAgain] = useState(false);

    const onChangeNotShowAgain = (e) => {
        setNotShowAgain(e.target.checked);
    }

    const widthStyle = useViewport(CONFIRM_POPUP_WIDTH_STYLE)

    return (
        <PopupPaper style={widthStyle}>
            <div className="d-flex flex-column gap-1 ai-center jc-center full-width">
                <div className="d-flex flex-column gap-0_5 ai-center jc-center full-width">
                    <Typography textAlign="center" variant="h4">{title}</Typography>
                    <Typography textAlign="center" variant="subtitle1">{message}</Typography>
                </div>
                {
                    notShowAgainCheckbox &&
                    <div className="d-flex flex-row ai-center full-width px-1 bs-border-box">
                        <FormGroup>
                            <FormControlLabel control={<Checkbox size="small" checked={notShowAgain} onChange={onChangeNotShowAgain} />} label="Don't show this again"></FormControlLabel>
                        </FormGroup>
                    </div>
                }
                {
                    buttons &&
                    <div className="d-flex flex-row gap-1 ai-center jc-end full-width">
                        {  
                            buttons.map((button, index) => <ConfirmPopupButton key={index} buttonData={button} notShowAgainCheckbox={notShowAgainCheckbox} notShowAgain={notShowAgain} />)
                        }
                    </div>
                }
            </div>
        </PopupPaper>
    )
}

export default ConfirmPopup;